import { useTrackResourceView } from "@core/activities/hooks";
import { Resource } from "@core/shared/types";
import { trans } from "@mongez/localization";

type ResourceUrlProps = {
  resource: Resource;
};

export function ResourceUrl({ resource }: ResourceUrlProps) {
  const { trackResourceView } = useTrackResourceView(resource);
  return (
    <a
      href={resource.url}
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary-800 hover:underline"
      onClick={trackResourceView}
    >
      {trans("openUrl")}
    </a>
  );
}
